import { createApi } from '@reduxjs/toolkit/dist/query/react';

import serverRoutes from '@app/utils/server-routes';

import { DashboardChartSettingsForGraphData } from '@app/interfaces/dashboards.type';

import { ReportChartResponse } from '@app/interfaces/report.type';

import { baseQuery } from '../baseQuery';

/* Graph Data */
export const chartsGraphDataApi = createApi({
  reducerPath: 'chartsGraphDataApi',
  tagTypes: ['chartsGraphData'],
  baseQuery: baseQuery,
  endpoints: (build) => ({
    getGraphData: build.query<
      ReportChartResponse,
      { id: string; settings: DashboardChartSettingsForGraphData }
    >({
      query: (body) => ({
        url: serverRoutes.chartData,
        body: { id: body.id, ...body.settings },
        method: 'POST',
      }),
      transformErrorResponse: (response) => {
        if (typeof response.status === 'number' && response.data) {
          const res = response.data as ReportChartResponse;
          return { ...res, data: { ...res.data, errorStatus: response.status } };
        }
      },
    }),
    getChatGraphData: build.query<
      ReportChartResponse,
      { id: string; settings: DashboardChartSettingsForGraphData }
    >({
      query: (body) => ({
        url: serverRoutes.chatChartData,
        body: { id: body.id, ...body.settings },
        method: 'POST',
      }),
      transformErrorResponse: (response) => {
        if (typeof response.status === 'number' && response.data) {
          const res = response.data as ReportChartResponse;
          return { ...res, data: { ...res.data, errorStatus: response.status } };
        }
      },
    }),
  }),
});

export const {
  useLazyGetGraphDataQuery,
  useGetGraphDataQuery,
  useGetChatGraphDataQuery,
  useLazyGetChatGraphDataQuery,
} = chartsGraphDataApi;
